import React, {useState} from "react";
import {Link, useHistory} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import UIDatePicker from "components/datepicker";
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import StringUtil from "utils/StringUtil";
import UI from "components/UI";
import UIUtils from "utils/UIUtils";
import codeDataStore from "../../../../common/codedata/store/CodeDataStore";
import UISelect from "../../../../components/selectbox/UISelect";
import userRestRepository from "../../../../common/user/repository/UserRestRepository";
import userStore from "../../../../common/user/store/UserStore";



function ContentsContainer() {
	const modaladm2000 = useToggleState({});
	const serverUrl = 'http://dev.fund.win-win.or.kr/';
	const sectors = [
		'동반성장 투자재원','상생형 창법 밴처기업 지원사업','공동투자형 기술개발','산업혁신운동','대중소 상생형 스마트공장','대중소기업 혁신 파트너십','성과공유제',
		'협력이익공유제','대중소기업 동반진출','동반성장 문화확산-신용카드 영세가맹점 지원사업','동반성장 문화확산-협력시ESG 평가지원사업','동반성장 문화확산-혁신주도형 동반성장',
		'분사기업(스핀오프) 상생협력 사업','상생결제제도 운영','지역사회 동반성장 지원사업','기술유출방지시스템'
	]



	const [isChk,setIsChk] = useState(false);
	const [DonReqDate,setDonReqDate] = useState(new Date());
	const [amtList, setAmtList] = React.useState<any[]>([{ BIZ_DON_AMT : 0, BIZ_CD : '', FUN_PUR_USE_CD : '', num : 0 , checked : false}]);
	const [nextNum,setNextNum] = useState(1); //amtList 고유 key
	const [type,setType] = useState('M');
	const [isAllChk,setIsAllChk] = useState(false);
	const [totalAmt, setTotalAmt] = useState(0);
	const [isConfirm, setIsConfirm] = useState(false);
	const [elecApprYn, setElecApprYn] = useState('N');
	const [personId, setPersonId] = useState('');
	const [bizList,setBizList] = useState<any>([]);
	const [REC,setREC] = useState<any>([]);
	const [funPurUseCd,setFunPurUseCd] = useState(''); //기부금 사용용도

	//밑에 담당자 정보
	const [corpNm,setCorpNm] = useState(''); //과제명
	const [bizNo,setBizNo] = useState(''); //사업자번호
	const [corpRegNo,setCorpRegNo] = useState(''); //사업자번호
	const [personNm,setPersonNm] = useState(''); //이름
	const [posiNm,setPosiNm] = useState(''); //직급
	const [deptNm,setDeptNm] = useState(''); //부서명
	const [emailAdres,setEmailAdres] = useState(''); //이메일
	const [ofcTelNo,setOfcTelNo] = useState(''); //전화번호

	async function initCall(){

		let param = {};

		const response:any = await CommonUtil.execute({
			url:'TbComPersonEntityMapper_select_bizno',
			data: param
		})

		const result = response;
		console.log(result)
		if(result.REC.length != 0){
			setREC(result.REC);
			const personId = userStore.userModel?.getPersonId();
			console.log("personId : " + personId)
			let info = result.REC.filter(a => a.PERSON_ID == personId)[0]
			if(info.length == 0){
				info = result.REC[0];
			}

			setPersonId(info.PERSON_ID);
			setCorpNm(info.CORP_NM);
			setBizNo(info.BIZ_NO);
			setCorpRegNo(info.CORP_REG_NO);
			setPersonNm(info.PERSON_NM);
			setPosiNm(info.POSI_NM);
			setDeptNm(info.DEPT_NM);
			setEmailAdres(info.EMAIL_ADRES);
			setOfcTelNo(info.OFC_TEL_NO);
		}

		

		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}
	};

	React.useEffect(() => {
		codeDataStore.read(
			"cfms.portalBizCdList", "[FPUC]"
		).then(() => {
			console.log("cfms.portalBizCdList", codeDataStore.get("cfms.portalBizCdList"))
		});

		setBizList(codeDataStore.get("cfms.portalBizCdList"));

		initCall();

	},[]);

	const history = useHistory();

	const handleSelect = (e) => {
		let engReg = /[^a-zA-Z]/g;
		let numReg = /[^0-9]/g;
		let name = e.target.name;

		let type = name.replace('select', '').replace(engReg, '').toLowerCase();
		let index = name.replace(numReg, '');
		changeVal(e.target.value, type, index);
	};

	const manageSelect = (e) => {
		let selectManage = REC.filter(a => a.PERSON_ID == e.target.value);

		if(selectManage.length != 0){
			let info = selectManage[0];
			setPersonId(info.PERSON_ID)
			setCorpNm(info.CORP_NM);
			setBizNo(info.BIZ_NO);
			setCorpRegNo(info.CORP_REG_NO);
			setPersonNm(info.PERSON_NM);
			setPosiNm(info.POSI_NM);
			setDeptNm(info.DEPT_NM);
			setEmailAdres(info.EMAIL_ADRES);
			setOfcTelNo(info.OFC_TEL_NO);
		}

	};

	function changeVal(val, type, index){
		let newList = [...amtList];
		if(type == 'amt'){
			newList[index].BIZ_DON_AMT = val;
		}else if(type == 'bizcd'){
			newList[index].BIZ_CD = val;
		}else if(type == 'funpurusecd'){
			newList[index].FUN_PUR_USE_CD = val;
		}else if(type == 'checked'){
			newList[index].checked = val;
		}else if(type == 'type'){
			setType(val);
		}
		if(type != 'type') setAmtList(newList);
		if(type == 'amt'){
			let sum = newList.reduce((total, amt) => {
				return Number(amt.BIZ_DON_AMT) + total
			}, 0);
			setTotalAmt(sum);
		}

		console.log('type : ' + type)
		console.log('val : ' + val)
	}

	function addList(){
		const nextAmt = amtList.concat({
			BIZ_DON_AMT : 0, BIZ_CD : '', FUN_PUR_USE_CD : '', num : nextNum, checked : false
		});
		setNextNum(nextNum + 1);
		setAmtList(nextAmt);
	}

	function deleteList(){
		let newList = amtList.filter(function(data) {
			return !data.checked
		});

		if(newList.length != 0){
			let sum = newList.reduce((total, amt) => {
				return Number(amt.BIZ_DON_AMT) + total
			}, 0);
			setTotalAmt(sum); //삭제 후 토탈 재계산

			setAmtList(newList);
		}else{
			//전체 삭제시 초기화
			newList = [{ BIZ_DON_AMT : 0, BIZ_CD : '', FUN_PUR_USE_CD : '', num : 0 , checked : false}];
			setAmtList(newList);
			setTotalAmt(0);
			setIsAllChk(false);
			setNextNum(1);
		}


	}

	function isChecked(element)  {
		if(element.checked == false)  {
			return true;
		}
	}

	const checkBoxHandler = (e) => {

		if(e.target.name === 'ch-all'){
			setIsAllChk(e.target.checked);
		} else {
			let numReg = /[^0-9]/g;
			let name = e.target.name;
			let index = name.replace(numReg, '');
			changeVal(e.target.checked, 'checked', index);
		}
		if(e.target.name != 'ch-all'){
			let isAll = false;

			if(amtList.find(isChecked) == undefined){
				isAll = true;
			}
			setIsAllChk(isAll);

		}else{
			let newList = [...amtList];
			let allCheckBol = e.target.checked;
			newList = newList.map(e => {
				e.checked = allCheckBol;
				return e;
			});
			setAmtList(newList);
		}
	};

	const isChkValid = () => {

		if(!isChk){
			alertModalCheck();
			return false;
		}
		
		if(!DonReqDate){
			alertModal("[출연 신청일]");
			return false;
		}
		
		if(amtList.filter(a =>a.BIZ_CD == '' || a.BIZ_CD == '선택하세요').length != 0){
			alertModal("[출연 사업]");
			return false;
		}
		
		if(amtList.filter(a => (a.BIZ_DON_AMT == 0)).length != 0){
			alertModal("[출연 금액]");
			return false;
		}
		
		if(amtList.filter(a => (a.FUN_PUR_USE_CD == '')).length != 0){
			alertModal("[기금사용용도]");
			return false;
		}
		
		if(amtList.filter(a => (a.BIZ_DON_AMT == 0)).length != 0){
			alertModal("[출연 금액]");
			return false;
		}

		if(personNm == ''){
			alertModal("[담당자]");
			return false;
		}

		if(totalAmt == 0){
			alertModal("");
			return false;
		}


		confirmModal();


		return false;

	}

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	async function saveConfirm(checked){
		//DON_CONT_DIV_CD -> type 기부내용코드 C현물 M금전

		let year = DonReqDate.getFullYear();
		let month = DonReqDate.getMonth()+1;
		let day = DonReqDate.getDate();

		let donReqDateText = year+'-'+dateLpad(month)+'-'+dateLpad(day);

		let param = {
			"BIZ_NO": bizNo,
			"DON_REQ_DIV_CD": 'B',
			"DON_CONT_DIV_CD": type,
			"DON_REQ_DATE": donReqDateText,
			"ELEC_APPR_YN": elecApprYn,
			"AMT_LIST": amtList,
			"PERSON_ID": personId,
			"PERSON_NM" : personNm,
			"POSI_NM" : posiNm,
			"DEPT_NM" : deptNm,
			"EMAIL_ADRES" : emailAdres,
			"OFC_TEL_NO" : ofcTelNo,
			'YEAR' : new Date().getFullYear()+''
		};

		let elecYn = 'N';
		if(checked){
			//전자인증수정
			const result = await userRestRepository.certify("전자서명값");
			if(result.result){
				param.ELEC_APPR_YN = 'Y';
				saveDon(param);
			}
		}else{
			saveDon(param);
		}
	}

	async function saveDon(param:any){
		//바로 저장 진행
		const response:any = await CommonUtil.execute({
			url:'usr_2000',
			data: param
		})

		const result = response;
		console.log(result)
		if(amtList.length != 1){
			//리스트 페이지로 이동
			let dataToSend = {};
			// 다른 페이지로 이동하면서 데이터 전달
			history.push({
				pathname: './usr_2002',
				state: { data: dataToSend }
			});
		}else{
			//상세로 갈수있도록 수정해야함 //전역변수에 값 넣을떄 같이 수정 // 06/10
			//리스트 페이지로 이동
			let dataToSend = {};
			// 다른 페이지로 이동하면서 데이터 전달
			history.push({
				pathname: './usr_2002',
				state: { data: dataToSend }
			});
		}
	}


	const alertModal = async (chk) => {
		const value = await UIUtils.alert(<>
			<div className='ta-center'> 필수 입력이 완료되지 않았습니다.<br/>
			다시 확인 후 저장해 주세요.<br/>
			{(chk=="" || chk == null ? "" : chk)}
			</div>
		</>);
	}

	const alertModalCheck = async () => {
		const value = await UIUtils.alert(<>
			<div className='ta-center'>* 필수 입력이 완료되지 않았습니다.<br/>
			출연신청 안내 동의(필수) 체크 여부 확인 바랍니다.</div>
		</>);
	}


	const confirmModal = async () => {
		const value = await UIUtils.confirm(
			<p className="msg">
				저장하시겠습니까?<br/>
			</p>
		);
		if(value){
			elecConfirm();
		}
		console.log("confirmModal", value);
	}

	const elecConfirm = async () => {
		const value = await UIUtils.elecConfirm(
			<p className="msg">
				출연신청서에 대한 전자인증 또는 직인본 첨부를 진행하시겠습니까?<br/>
				- 전자인증을 완료하면 출연신청서를 첨부하지 않아도 자동으로 신청서가 제출됩니다.<br/>
				- 전자인증이 어려운경우, 출연신청서를 프린트하시어 직인본 첨부하셔야 합니다.
			</p>
		);

		saveConfirm(value);

		console.log("confirmModal", value);
	}


	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">기금출연</Link></li>
					<li><Link to="#">출연신청</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">출연신청</h1>
					<section className="fund-section">
						<div className="hz-root hz-gap10 hz-item mb15">
							<h3 className="section-title">출연신청 안내 동의</h3>
							<p className="tx-msg"><span className="fc-pri">※ 신청 정보는 출연번호 상세페이지에서 미리보기 및 인쇄 가능합니다.</span></p>
						</div>
						<div className="hz-root hz-gap10 hz-sb mb15">
							<h3 className=""></h3>
							<p className="tx-msg"><span className="fc-pri">*</span>&nbsp;필수 입력</p>
						</div>
						<form className="sf sf-1row" name="" action="" method="">
							<div className="hz-root hz-sb">
							<label htmlFor="ch-1" className="hz-item ip-ch-label ip-ch-18">
									<input id="ch-1" className="ip-ch" type="checkbox" checked={isChk} onChange={(e) => setIsChk(e.target.checked)} />
									<span className="check"></span>
									<span className="txt fw400">안내사항을 확인하였으며, 안내사항에 동의합니다(필수)</span>
								</label>
								<Button color="gray-o" size="sm" onClick={modaladm2000.open}>안내사항 보기</Button>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">출연 내용</h3>
						<div className="fo fo-col2">
							<div className="inner">
								<div className="fo-item req">
									<p className="fo-key">출연 신청일</p>
									<div className="fo-value">
										<div className="w320">
											<UIDatePicker
												value={DonReqDate}
												valueChanged={(value) => {setDonReqDate(value);}}
												minDate={new Date()}
											/>

										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">기부내용</p>
									<div className="fo-value">
										<div className="sl sl-md w320">
											<select name={'selectType0'} onChange={(e) => handleSelect(e)}>
												<option value={'M'}>금전</option>
												<option value={'C'}>현물</option>
											</select>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<div className="hz-root hz-gap10 hz-item">
								<h3 className="section-title">출연 금액</h3>
								<p className="tx-msg"><span className="fc-pri">※ 출연금은 최소 1개 이상을 입력해야 합니다. 기금사용용도는 대표용도 1개를 자율선택해 주세요.</span></p>
							</div>
							<div className="hz-root hz-gap5">
								<Button color='pri-o' size="sm" onClick={addList}>행추가</Button>
								<Button color='gray-o' size="sm" onClick={deleteList}>행삭제</Button>
							</div>
						</div>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="60px" />
										<col width="480px" />
										<col />
										<col width="300px" />
									</colgroup>
									<thead>
										<tr>
											<th>
												<label htmlFor="ch-all" className="hz-item ip-ch-label ip-ch-18">
													<input id="ch-all" className="ip-ch" type="checkbox" name={'ch-all'} checked={isAllChk} onChange={(e) => checkBoxHandler(e)}/>
													<span className="check"></span>
												</label>
											</th>
											<th scope="col"><span className="th-req">출연 사업</span></th>
											<th scope="col"><span className="th-req">출연 금액</span></th>
											<th scope="col"><span className="th-req">기금사용용도</span></th>
										</tr>
									</thead>
									<tbody>


									{amtList.map((amt, idx) => (
										<tr key={idx}>
											<td>
												<label htmlFor={'ch-t1'+idx} className="hz-item ip-ch-label ip-ch-18">
													<input id={'ch-t1'+idx} className="ip-ch" name={'isChk'+idx} type="checkbox" checked={amt.checked} onChange={(e) => checkBoxHandler(e)} />
													<span className="check"></span>
												</label>
											</td>
											<td>
												<div className="sl sl-md">
													<select name={'selectBizCd'+idx} onChange={(e) => handleSelect(e)}>
														<option>선택하세요</option>
														{codeDataStore.get("cfms.portalBizCdList").map((sec, idx) =>
															<option key={idx} value={sec.code}>{sec.name}</option>
														)}
													</select>
												</div>
											</td>
											<td>
												<div className="fund-form-group">
													<div className="fund-form-items tf-unit">
														<UIInput className={'tf tf-md ta-right'}
																 value={StringUtil.formatNumber(Number(amt.BIZ_DON_AMT)) || "0"}
																 valueChanged={(value) => {
																	 let tmpVal = value.replace(/[^0-9]/g, "");
																	 changeVal(tmpVal, 'amt', idx);
																 }}
																 attrs={{ maxLength: 21 }}
														/>
														<span className="u">원</span>
													</div>
													<div className="fund-form-items tx-msg ml10"><span className="fc-pri">(
														{StringUtil.isNotEmpty(amt.BIZ_DON_AMT + "")
															? StringUtil.numKorPattern(amt.BIZ_DON_AMT) + " 원"
															: "원"}
														)</span>
													</div>
												</div>
											</td>
											<td>
												<div className="fund-form-items tf-unit">
													<div className="sl sl-md w200">
														<select name={'selectFunPurUseCd'+idx} onChange={(e) => handleSelect(e)}>
														<option>선택하세요</option>
														{codeDataStore.get("[FPUC]").map((sec, idx) =>
															<option key={idx} value={sec.code}>{sec.name}</option>
														)}
													</select>
													</div>
												</div>
											</td>

										</tr>
									))}

									</tbody>
								</table>
							</div>
							<div className="tb-total">
								<div className="tb-total-items">
									출연 금액 합계
								</div>
								<div className="tb-total-items">
									<div className="fund-form-items tf-unit">
										<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(totalAmt)) || "0"} placeholder={''}  readOnly={true}/>
										<span className="u">원</span>
									</div>
									<p className="tx-msg"><span className="fc-pri">
									(
										{StringUtil.isNotEmpty(totalAmt + "") ?
										 StringUtil.numKorPattern(totalAmt) + " 원" : "원"}
									)</span></p>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">출연 기업 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpRegNo} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.bizCrpFormat(bizNo)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자</p>
									<div className="fo-value">
										{/*<UIInput className={'tf tf-md w100p'} value={personNm} valueChanged={(value) => {setPersonNm(value)}} placeholder={''}/>*/}
										<div className="sl sl-md w120">
											<select name="personId" id="personId" value={personId} onChange={(manageSelect)}>
												{REC.map((info, idx) => (
													<option value={info.PERSON_ID}>{info.PERSON_NM}</option>
												))}
											</select>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">직급</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={posiNm} valueChanged={(value) => {setPosiNm(value)}} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={deptNm} valueChanged={(value) => {setDeptNm(value)}} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={emailAdres} valueChanged={(value) => {setEmailAdres(value)}} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.telephoneFormat(ofcTelNo)} valueChanged={(value) => {setOfcTelNo(value)}} placeholder={''} />
									</div>
								</div>
							</div>
						</form>
					</section>
					<div className="hz-root hz-right hz-gap10 mt30">
						<Button color="gray-o" size="md" href="usr_2002">목록</Button>
						<Button color="pri" size="md" onClick={() => isChkValid()}>저장</Button>
					</div>
				</main>
			</div>
			{/* modal - 안내사항 보기 */}
			<ModalPopup
				open={modaladm2000.isShowing}
				title="안내사항 보기"
				size="mid"
				onClose={modaladm2000.close}
			>
				<div className="modal-con">
					<div className="fww-noti">
						<section className="mb30">
							<h3>출연절차</h3>

							{/* [M.20240716] 수정 */}
							<div className="step">
								<dl>
									<dt>01 출연신청</dt>
									<dd>
										아래[저장]버튼 누른후, <br/>
										출연신청서 전자서명<br/>
										(출연신청서 직인도 가능)
									</dd>
								</dl>
								<dl>
									<dt>02 출연금 입금</dt>
									<dd>
										출연기업별 지정계좌 <br/>
										(하나은행)으로 출연금 입금
									</dd>
								</dl>
								<dl>
									<dt>03 출연확인</dt>
									<dd>
										재단에서 출연금 입금확인후 <br/>
										기부금영수증 등록
									</dd>
								</dl>
								<dl>
									<dt>04 기부금영수증 출력</dt>
									<dd>
										본 시스템내에서 상시출력 가능
									</dd>
								</dl>
							</div>
							{/* [M.20240716] 수정 */}

							<div className="tx-msg">※ 출연신청 이후, 별도 확인절차는 없으며 출연신청금액을 지정계좌에 입금해주시면 됩니다.</div> {/* [M.20240716] 수정 */}
							<div className="tx-msg">※ 재단 사업담당자가 입금내역을 확인하여 기부금영수증을 발급합니다.</div> {/* [M.20240716] 추가 */}
						</section>

						{/* [M.20240716] 삭제 */}
						{/*
						<section className="mb30">
							<h3>기금활용사업</h3>
							<ul className="bz">
								<li><span>동반성장<br />투자재원</span></li>
								<li><span>공동투자형<br />기술개발</span></li>
								<li><span>산업혁신<br />운동</span></li>
								<li><span>대·중소 상생형<br />스마트공장</span></li>
								<li><span>대·중소기업<br />혁신파트너</span></li>
								<li><span>대·중소기업<br />동반진출</span></li>
								<li><span>기업자율형<br />상생프로그램</span></li>
								<li><span>성과<br />공유제</span></li>
								<li><span>협력이익<br />공유제</span></li>
								<li><span>협력사ESG<br />평가지원</span></li>
							</ul>
						</section>
						*/}

						<dl className="guide">
							<dt>유의사항</dt>
							<dd>
								<ul className="list-group">
									<li>
										출연신청 시 활용사업을 지정하여 출연하여야 하면, 수납처리가 완료된 출연금은 신청 시 지정된 사업으로만 지원할 수 있습니다.<br />
										<span className="fc-pri">타 사업으로 지원을 원하는 경우 ‘상생협력기금 운영위원회’의 승인을 받아야 출연금 사업간 전용 후 지원 가능합니다.</span>
									</li>
									<li>
										출연금은 「상속세 및 증여세법」 에따라 출연 일자로 부터 3년 이내 지원 되어야 합니다.<br />
										<span className="fc-pri">3년을 초과하여 출연금 잔액이 남아 있을 경우 증여세가 부과될 수 있습니다.</span>
									</li>
									<li>
										상생협력기금 종합관리시스템 오픈(21.7.21) 이후 출연계좌번호가 가상계좌로 변경되었습니다.<br />
										<span className="fc-pri">(기존) 기업별, 사업별 실물계좌 → (변경) 기업별 가상계좌 반드시 출연신청서 내 계좌번호를 확인하여 출연해 주시기 바랍니다.</span>
									</li>
								</ul>
							</dd>
						</dl>
					</div>
				</div>
				<div className="modal-bottom">
					<Button color="pri" size="md" onClick={modaladm2000.close}>확인</Button>
				</div>
			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;